import { render, staticRenderFns } from "./FilterDescription.vue?vue&type=template&id=04197ab6&scoped=true&"
import script from "./FilterDescription.vue?vue&type=script&lang=ts&"
export * from "./FilterDescription.vue?vue&type=script&lang=ts&"
import style0 from "./FilterDescription.vue?vue&type=style&index=0&id=04197ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04197ab6",
  null
  
)

export default component.exports